import { trpc } from '@/shared/api';

/** 상품에 적용할 카테고리 템플릿(대표 소분류 → 대분류 순 상속). 없으면 null. */
export const useProductEditAreaTemplateQuery = (productId: string) =>
  trpc.productManagement.editAreaTemplates.forProduct.useQuery({ productId });
